import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "leading-17 mb-3" }
const _hoisted_2 = { class: "grid grid-cols-1 grid-rows-3 md:grid-cols-3 md:grid-rows-2 gap-6" }
const _hoisted_3 = { class: "flex justify-center items-center" }
const _hoisted_4 = { class: "flex justify-between h-12 border border-gray-200 rounded-lg shadow overflow-hidden -mt-10" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "w-px bg-light-2" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "w-px bg-light-2" }, null, -1)
const _hoisted_7 = { class: "grid grid-cols-1 md:grid-cols-3 gap-6" }
const _hoisted_8 = { class: "grid grid-cols-1 md:grid-cols-3 gap-6 mt-6" }
const _hoisted_9 = { class: "flex items-center justify-center mt-6" }
const _hoisted_10 = { class: "grid grid-cols-1 md:grid-cols-3 gap-7" }
const _hoisted_11 = { class: "flex items-center justify-center mt-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dropdown_menu_item = _resolveComponent("dropdown-menu-item")!
  const _component_dropdown_menu = _resolveComponent("dropdown-menu")!
  const _component_card_chart = _resolveComponent("card-chart")!
  const _component_app_icon = _resolveComponent("app-icon")!
  const _component_card_kpi = _resolveComponent("card-kpi")!
  const _component_card_group = _resolveComponent("card-group")!
  const _component_app_section = _resolveComponent("app-section")!
  const _component_recommended_actions_section = _resolveComponent("recommended-actions-section")!
  const _component_automations_list = _resolveComponent("automations-list")!
  const _component_app_button = _resolveComponent("app-button")!
  const _component_mails_list_item = _resolveComponent("mails-list-item")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_app_section, { class: "pt-5 pb-8 bg-light-2" }, {
      default: _withCtx(() => [
        _createElementVNode("h1", _hoisted_1, _toDisplayString(_ctx.$t("pages.dashboard.header")), 1),
        _createVNode(_component_card_group, {
          title: _ctx.$t('general.performance')
        }, {
          sorting: _withCtx(() => [
            _createVNode(_component_dropdown_menu, {
              label: 
                        `${_ctx.$t('general.last')} ${_ctx.kpiDays} ${_ctx.$t('general.days')}`
                    
            }, {
              default: _withCtx(() => [
                _createVNode(_component_dropdown_menu_item, {
                  label: `${_ctx.$t('general.last')} 7 ${_ctx.$t('general.days')}`,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.kpiDays = 7))
                }, null, 8, ["label"]),
                _createVNode(_component_dropdown_menu_item, {
                  label: 
                            `${_ctx.$t('general.last')} 30 ${_ctx.$t('general.days')}`
                        ,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.kpiDays = 30))
                }, null, 8, ["label"]),
                _createVNode(_component_dropdown_menu_item, {
                  label: 
                            `${_ctx.$t('general.last')} 60 ${_ctx.$t('general.days')}`
                        ,
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.kpiDays = 60))
                }, null, 8, ["label"]),
                _createVNode(_component_dropdown_menu_item, {
                  label: 
                            `${_ctx.$t('general.last')} 90 ${_ctx.$t('general.days')}`
                        ,
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.kpiDays = 90))
                }, null, 8, ["label"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_card_chart, {
                header: _ctx.$t('pages.dashboard.netSales'),
                datasets: _ctx.chart1Dataset,
                class: "md:block row-span-2 md:col-span-2",
                loading: _ctx.revenueChartsLoading
              }, null, 8, ["header", "datasets", "loading"]),
              _createVNode(_component_card_kpi, {
                header: _ctx.$t('pages.dashboard.totalDrivenRevenue'),
                currency: _ctx.currency,
                value: 
                        parseFloat(_ctx.kpis.maatoo_revenue_total.value.toFixed(1))
                    ,
                trend: _ctx.kpis.maatoo_revenue_total.trend,
                loading: _ctx.kpisLoading
              }, {
                icon: _withCtx(() => [
                  _createVNode(_component_app_icon, { name: "CurrencyDollar" })
                ]),
                _: 1
              }, 8, ["header", "currency", "value", "trend", "loading"]),
              _createVNode(_component_card_kpi, {
                header: _ctx.$t('pages.dashboard.numberOfConversions'),
                value: parseFloat(_ctx.kpis.conversion_total.value.toFixed(1)),
                trend: _ctx.kpis.conversion_total.trend,
                loading: _ctx.kpisLoading
              }, {
                icon: _withCtx(() => [
                  _createVNode(_component_app_icon, { name: "Conversion" })
                ]),
                _: 1
              }, 8, ["header", "value", "trend", "loading"])
            ])
          ]),
          _: 1
        }, 8, ["title"])
      ]),
      _: 1
    }),
    _createVNode(_component_recommended_actions_section),
    _createVNode(_component_app_section, { class: "pt-4 pb-8 bg-light-2" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.activeSection = 'automations')),
              class: _normalizeClass(["bg-white w-64 flex items-center justify-center text-sm font-medium cursor-pointer", [
                        _ctx.activeSection === 'automations'
                            ? 'text-dark-1 border-b-2 border-blue-500'
                            : 'text-dark-3'
                    ]])
            }, _toDisplayString(_ctx.$t("pages.dashboard.automations")), 3),
            _hoisted_5,
            _createElementVNode("div", {
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.activeSection = 'mails')),
              class: _normalizeClass(["bg-white w-64 flex items-center justify-center text-sm font-medium cursor-pointer", [
                        _ctx.activeSection === 'mails'
                            ? 'text-dark-1 border-b-2 border-blue-500'
                            : 'text-dark-3'
                    ]])
            }, _toDisplayString(_ctx.$t("pages.dashboard.mails")), 3),
            _hoisted_6
          ])
        ])
      ]),
      _: 1
    }),
    (_ctx.activeSection === 'automations')
      ? (_openBlock(), _createBlock(_component_app_section, {
          key: 0,
          class: "pb-24 bg-light-2"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_card_group, {
              title: _ctx.$t('pages.dashboard.automations')
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_card_kpi, {
                    header: _ctx.$t('pages.mails.totalMailsSent'),
                    value: 
                        parseFloat(
                            _ctx.kpis.automation_mail_sent_total.value.toFixed(1)
                        )
                    ,
                    trend: _ctx.kpis.automation_mail_sent_total.trend,
                    loading: _ctx.kpisLoading
                  }, {
                    icon: _withCtx(() => [
                      _createVNode(_component_app_icon, { name: "MailOpen" })
                    ]),
                    _: 1
                  }, 8, ["header", "value", "trend", "loading"]),
                  _createVNode(_component_card_kpi, {
                    header: _ctx.$t('pages.mails.numberOfConversions'),
                    value: 
                        parseFloat(
                            _ctx.kpis.automation_conversion_total.value.toFixed(1)
                        )
                    ,
                    trend: _ctx.kpis.automation_conversion_total.trend,
                    loading: _ctx.kpisLoading
                  }, {
                    icon: _withCtx(() => [
                      _createVNode(_component_app_icon, { name: "Conversion" })
                    ]),
                    _: 1
                  }, 8, ["header", "value", "trend", "loading"]),
                  _createVNode(_component_card_kpi, {
                    header: _ctx.$t('pages.automations.totalRevenue'),
                    currency: _ctx.currency,
                    value: 
                        parseFloat(
                            _ctx.kpis.automation_revenue_total.value.toFixed(1)
                        )
                    ,
                    trend: _ctx.kpis.automation_revenue_total.trend,
                    loading: _ctx.kpisLoading
                  }, {
                    icon: _withCtx(() => [
                      _createVNode(_component_app_icon, { name: "CurrencyDollar" })
                    ]),
                    _: 1
                  }, 8, ["header", "currency", "value", "trend", "loading"])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_card_chart, {
                    header: _ctx.$t('pages.dashboard.netAutomationSales'),
                    datasets: _ctx.chart2Dataset,
                    class: "md:col-span-2",
                    loading: _ctx.revenueChartsLoading
                  }, null, 8, ["header", "datasets", "loading"]),
                  _createVNode(_component_automations_list)
                ])
              ]),
              _: 1
            }, 8, ["title"]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_app_button, {
                "button-style": "white",
                class: "shadow-lg",
                onClick: _ctx.goToAutomations
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("pages.dashboard.goToAutomations")), 1)
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.activeSection === 'mails')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createVNode(_component_app_section, { class: "bg-light-2" }, {
            default: _withCtx(() => [
              (_ctx.kpis)
                ? (_openBlock(), _createBlock(_component_card_group, {
                    key: 0,
                    title: _ctx.$t('pages.dashboard.mails')
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_10, [
                        _createVNode(_component_card_kpi, {
                          header: _ctx.$t('pages.mails.totalMailsSent'),
                          value: 
                            parseFloat(_ctx.kpis.mail_sent_total.value.toFixed(1))
                        ,
                          trend: _ctx.kpis.mail_sent_total.trend,
                          loading: _ctx.kpisLoading
                        }, {
                          icon: _withCtx(() => [
                            _createVNode(_component_app_icon, { name: "MailOpen" })
                          ]),
                          _: 1
                        }, 8, ["header", "value", "trend", "loading"]),
                        _createVNode(_component_card_kpi, {
                          header: _ctx.$t('pages.mails.numberOfConversions'),
                          value: 
                            parseFloat(
                                _ctx.kpis.mail_conversion_total.value.toFixed(1)
                            )
                        ,
                          trend: _ctx.kpis.mail_conversion_total.trend,
                          loading: _ctx.kpisLoading
                        }, {
                          icon: _withCtx(() => [
                            _createVNode(_component_app_icon, { name: "Conversion" })
                          ]),
                          _: 1
                        }, 8, ["header", "value", "trend", "loading"]),
                        _createVNode(_component_card_kpi, {
                          header: _ctx.$t('pages.mails.totalRevenue'),
                          currency: _ctx.currency,
                          value: 
                            parseFloat(_ctx.kpis.mail_revenue_total.value.toFixed(1))
                        ,
                          trend: _ctx.kpis.mail_revenue_total.trend,
                          loading: _ctx.kpisLoading
                        }, {
                          icon: _withCtx(() => [
                            _createVNode(_component_app_icon, { name: "CurrencyDollar" })
                          ]),
                          _: 1
                        }, 8, ["header", "currency", "value", "trend", "loading"])
                      ])
                    ]),
                    _: 1
                  }, 8, ["title"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_app_section, { class: "pb-24" }, {
            default: _withCtx(() => [
              _createVNode(_component_card_group, {
                title: _ctx.$t('pages.dashboard.activeMails'),
                class: "mt-10 hidden md:block"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scheduledMails, (mail) => {
                    return (_openBlock(), _createBlock(_component_mails_list_item, {
                      mail: mail,
                      key: mail.id,
                      class: "mb-5",
                      action: "view"
                    }, null, 8, ["mail"]))
                  }), 128)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeMails, (mail) => {
                    return (_openBlock(), _createBlock(_component_mails_list_item, {
                      mail: mail,
                      key: mail.id,
                      class: "mb-5",
                      action: "view"
                    }, null, 8, ["mail"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["title"]),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_app_button, {
                  "button-style": "white",
                  class: "shadow-lg",
                  onClick: _ctx.goToMails
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("pages.dashboard.goToMails")), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ]),
            _: 1
          })
        ], 64))
      : _createCommentVNode("", true),
    _createVNode(_component_app_section, { class: "pb-24 bg-light-2" })
  ], 64))
}